const Logo = ({ color = "white", ...props }) => (
  <>
    {color === "white" && (
      <img style={{ width: 250 }} src={"/static/images/logo.png"} alt="logo" />
    )}
    {color === "black" && (
      <img style={{ width: 250 }} src={"/static/images/logo.png"} alt="logo" />
    )}
  </>
);

export default Logo;
